import { Injectable } from '@angular/core';
import { Select } from '@ngxs/store';
import { AppState, AppStateModel } from './reducer';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  @Select(AppState)
  AppState!: Observable<AppStateModel>;

}
